export const OPEN_PANE = "@layout/OPEN_PANE";
export const CLOSE_PANE = "@layout/CLOSE_PANE";
